export default __webpack_public_path__ + "static/media/icon-eye.64dd90fc.svg";